/// <reference types="react-scripts" />
import { Box } from "@mui/material";
import * as React from "react";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { Translations } from "ui/Scripts/source/models/translations";
import { IDashboardChartData } from "../../../models/report/dashboardChartData";
import { CardContainer } from "../CardContainer";
import { DashboardCardProgress } from "../DashboardCard/DashboardCardProgress";
import { DashboardCardTitle } from "../DashboardCard/DashboardCardTitle";
import { BarChart } from "./BarChart";
import { Base } from "ui/Scripts/source/framework/base";

interface IDashboardBarChartProp {
    classes?: string;
    defaultTitle?: string;
    titlePrefix?: string;
    intialized: boolean;
    isLoading: boolean;
    chartData: IDashboardChartData;
    onPropertiesClick?: () => void;
}

/* eslint-disable react/prop-types */
export class DashboardBarChart extends React.Component<IDashboardBarChartProp, {}> {
    private legendContainerId = Base.getGuid();

    render() {
        const props = this.props;
        return (
            <>
                <DashboardCardTitle
                    title={props.chartData ? (props.titlePrefix ? props.titlePrefix : "") + props.chartData.title : props.defaultTitle}
                />
                {!props.intialized &&
                    <DashboardCardProgress isLoading={props.isLoading} />
                }
                {props.intialized && (
                    <CardContainer>
                        <DashboardCardProgress isLoading={props.isLoading} />
                        {props.intialized && props.chartData && props.chartData.dataSets &&
                            <Box sx={{ height: "100%", position: "relative", display: "flex" }}>
                                <Box sx={{ width: "70%", flexGrow: "1" }}>
                                    <BarChart
                                        title={props.chartData.title}
                                        dataId={props.chartData.dataId}
                                        labels={props.chartData.labels}
                                        dataSets={props.chartData.dataSets}
                                        legendContainerId={this.legendContainerId}
                                    />
                                </Box>
                                <Box id={this.legendContainerId} sx={{ width: "30%", maxWidth: "200px", height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                                </Box>
                            </Box>
                        }
                        {props.onPropertiesClick &&
                            <ToolButton
                                tooltip={Translations.Properties}
                                classes={"properties"}
                                onClick={props.onPropertiesClick}
                            />
                        }
                    </CardContainer>
                )}
                {props.children}
            </>
        );
    }
}
/* eslint-enable react/prop-types */